// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StepOne-module__infoBox--PzLao {
  display: flex;
  gap: 20px;
}

.StepOne-module__leftBox--bocXA {
  display: flex;
  flex-direction: column;
  width: 50%;
}

.StepOne-module__info--XBYVA > h4 {
  color: var(--color-primary);
  text-transform: uppercase;
  font-weight: 500;
  display: flex;
}

.StepOne-module__info--XBYVA > p {
  text-transform: uppercase;
  font-weight: 400;
  font-size: 14px;
}

.StepOne-module__info--XBYVA > p > span {
  text-transform: lowercase;
}

.StepOne-module__risksList--YFa45 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.StepOne-module__riskBox--wOOxb {
  display: flex;
  gap: 10px;
  align-items: center;
}

.StepOne-module__riskBox--wOOxb > p {
  margin: 0;
  background-color: rgb(43 93 235 / 5%);
  padding: 3px;
}

.StepOne-module__declorationBox--SeVsj {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 20px;
}
.StepOne-module__declorationBox--SeVsj > h4 {
  margin: 0 0 5px 0;
  font-size: 18px;
  font-weight: 500;
  color: var(--color-primary);
}
.StepOne-module__declorationLink--ufcgF {
  display: flex;
  align-items: center;
  gap: 10px;
}
.StepOne-module__declorationLink--ufcgF > a {
  text-decoration: none;
}
.StepOne-module__declorationLink--ufcgF > svg {
  color: var(--color-primary);
}

.StepOne-module__checkIcon--8j8VB > svg {
  display: flex;
  align-items: center;
  height: 20px;
  color: var(--color-primary);
}

.StepOne-module__infoIcon--fZU5N > svg {
  display: flex;
  align-items: center;
  height: 16px;
  color: var(--color-text-item-column);
}

.StepOne-module__rightBox--RyMFm {
  display: flex;
  flex-direction: column;
  width: 50%;
}

.StepOne-module__rightBox--RyMFm > h4 {
  color: var(--color-primary);
  text-transform: uppercase;
  font-weight: 500;
}

.StepOne-module__rightBox--RyMFm > p {
  margin: 0 0 10px 0;
}

.StepOne-module__formBox--kFCjt {
  flex-grow: 1;
  padding: 20px;
}

.StepOne-module__formBox--kFCjt > h4 {
  margin: 0 0 5px 0;
  font-size: 18px;
  font-weight: 500;
  color: var(--color-primary);
}

.StepOne-module__formBox--kFCjt > p {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--color-title);
}

.StepOne-module__colorBox--YJsJR > p > span {
  font-weight: bold;
  color: var(--color-primary);
}

.StepOne-module__colorBox--YJsJR {
  margin: 20px 0;
  display: flex;
  gap: 10px;
  align-content: center;
  justify-content: center;
  align-items: center;
  background-color: rgb(43 93 235 / 5%);
  border-radius: 20px;
  padding: 5px;
  width: 80%;
}

.StepOne-module__flexBox--s5_Ap {
  display: flex;
  gap: 30px;
  height: 40px;
}

.StepOne-module__colorBox--YJsJR > p {
  margin: 0;
}

.StepOne-module__icon--ojG6e > svg {
  color: var(--color-primary);
  font-size: 25px;
}

.StepOne-module__btnBox--oFS2k {
  display: flex;
  justify-content: flex-end;
}

.StepOne-module__roundedTextField--S7ADw .StepOne-module__MuiOutlinedInput-root--wabPA,
.StepOne-module__roundedTextField--S7ADw .StepOne-module__MuiInputLabel-root--Vz5sX {
  border-radius: 20px !important;
}

.StepOne-module__desktopContainer--iOd29 {
  padding: 10px;
}

.StepOne-module__rightBoxImg--l54Py {
  display: flex;
  flex-direction: column;
  width: 50%;
}

.StepOne-module__riskTitle--JZn_s {
  background-color: rgb(43 93 235 / 5%);
  padding: 3px;
  text-align: center;
  color: var(--color-primary);
}

.StepOne-module__info--XBYVA > h4 > span {
  display: flex;
  align-items: center;
  /* height: 16px; */
  color: var(--color-text-item-column);
}

.StepOne-module__info--XBYVA > h4 > span > svg {
  height: 16px;
  display: flex;
  align-items: center;
}

.StepOne-module__modalDesc--Ie3pl > h4 {
  background-color: rgb(43 93 235 / 5%);
  padding: 3px;
  text-align: center;
  color: var(--color-primary);
}

.StepOne-module__modalDesc--Ie3pl > p > span {
  color: var(--color-primary);
}

@media (max-width: 950px) {
  .StepOne-module__infoBox--PzLao {
    flex-direction: column;
  }

  .StepOne-module__leftBox--bocXA,
  .StepOne-module__rightBox--RyMFm {
    width: 100%;
  }

  .StepOne-module__formBox--kFCjt {
    width: 80%;
  }

  .StepOne-module__rightBoxImg--l54Py {
    display: none;
  }
}

@media (max-width: 600px) {
  .StepOne-module__flexBox--s5_Ap {
    flex-direction: column;
  }

  .StepOne-module__formBox--kFCjt {
    width: 90%;
  }

  .StepOne-module__colorBox--YJsJR {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/cancer-protection/step-1/StepOne.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".infoBox {\r\n  display: flex;\r\n  gap: 20px;\r\n}\r\n\r\n.leftBox {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 50%;\r\n}\r\n\r\n.info > h4 {\r\n  color: var(--color-primary);\r\n  text-transform: uppercase;\r\n  font-weight: 500;\r\n  display: flex;\r\n}\r\n\r\n.info > p {\r\n  text-transform: uppercase;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n}\r\n\r\n.info > p > span {\r\n  text-transform: lowercase;\r\n}\r\n\r\n.risksList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n\r\n.riskBox {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n.riskBox > p {\r\n  margin: 0;\r\n  background-color: rgb(43 93 235 / 5%);\r\n  padding: 3px;\r\n}\r\n\r\n.declorationBox {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-grow: 1;\r\n  padding: 20px;\r\n}\r\n.declorationBox > h4 {\r\n  margin: 0 0 5px 0;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  color: var(--color-primary);\r\n}\r\n.declorationLink {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n.declorationLink > a {\r\n  text-decoration: none;\r\n}\r\n.declorationLink > svg {\r\n  color: var(--color-primary);\r\n}\r\n\r\n.checkIcon > svg {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 20px;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.infoIcon > svg {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 16px;\r\n  color: var(--color-text-item-column);\r\n}\r\n\r\n.rightBox {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 50%;\r\n}\r\n\r\n.rightBox > h4 {\r\n  color: var(--color-primary);\r\n  text-transform: uppercase;\r\n  font-weight: 500;\r\n}\r\n\r\n.rightBox > p {\r\n  margin: 0 0 10px 0;\r\n}\r\n\r\n.formBox {\r\n  flex-grow: 1;\r\n  padding: 20px;\r\n}\r\n\r\n.formBox > h4 {\r\n  margin: 0 0 5px 0;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.formBox > p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: var(--color-title);\r\n}\r\n\r\n.colorBox > p > span {\r\n  font-weight: bold;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.colorBox {\r\n  margin: 20px 0;\r\n  display: flex;\r\n  gap: 10px;\r\n  align-content: center;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: rgb(43 93 235 / 5%);\r\n  border-radius: 20px;\r\n  padding: 5px;\r\n  width: 80%;\r\n}\r\n\r\n.flexBox {\r\n  display: flex;\r\n  gap: 30px;\r\n  height: 40px;\r\n}\r\n\r\n.colorBox > p {\r\n  margin: 0;\r\n}\r\n\r\n.icon > svg {\r\n  color: var(--color-primary);\r\n  font-size: 25px;\r\n}\r\n\r\n.btnBox {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.roundedTextField .MuiOutlinedInput-root,\r\n.roundedTextField .MuiInputLabel-root {\r\n  border-radius: 20px !important;\r\n}\r\n\r\n.desktopContainer {\r\n  padding: 10px;\r\n}\r\n\r\n.rightBoxImg {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 50%;\r\n}\r\n\r\n.riskTitle {\r\n  background-color: rgb(43 93 235 / 5%);\r\n  padding: 3px;\r\n  text-align: center;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.info > h4 > span {\r\n  display: flex;\r\n  align-items: center;\r\n  /* height: 16px; */\r\n  color: var(--color-text-item-column);\r\n}\r\n\r\n.info > h4 > span > svg {\r\n  height: 16px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.modalDesc > h4 {\r\n  background-color: rgb(43 93 235 / 5%);\r\n  padding: 3px;\r\n  text-align: center;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.modalDesc > p > span {\r\n  color: var(--color-primary);\r\n}\r\n\r\n@media (max-width: 950px) {\r\n  .infoBox {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .leftBox,\r\n  .rightBox {\r\n    width: 100%;\r\n  }\r\n\r\n  .formBox {\r\n    width: 80%;\r\n  }\r\n\r\n  .rightBoxImg {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .flexBox {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .formBox {\r\n    width: 90%;\r\n  }\r\n\r\n  .colorBox {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoBox": `StepOne-module__infoBox--PzLao`,
	"leftBox": `StepOne-module__leftBox--bocXA`,
	"info": `StepOne-module__info--XBYVA`,
	"risksList": `StepOne-module__risksList--YFa45`,
	"riskBox": `StepOne-module__riskBox--wOOxb`,
	"declorationBox": `StepOne-module__declorationBox--SeVsj`,
	"declorationLink": `StepOne-module__declorationLink--ufcgF`,
	"checkIcon": `StepOne-module__checkIcon--8j8VB`,
	"infoIcon": `StepOne-module__infoIcon--fZU5N`,
	"rightBox": `StepOne-module__rightBox--RyMFm`,
	"formBox": `StepOne-module__formBox--kFCjt`,
	"colorBox": `StepOne-module__colorBox--YJsJR`,
	"flexBox": `StepOne-module__flexBox--s5_Ap`,
	"icon": `StepOne-module__icon--ojG6e`,
	"btnBox": `StepOne-module__btnBox--oFS2k`,
	"roundedTextField": `StepOne-module__roundedTextField--S7ADw`,
	"MuiOutlinedInput-root": `StepOne-module__MuiOutlinedInput-root--wabPA`,
	"MuiInputLabel-root": `StepOne-module__MuiInputLabel-root--Vz5sX`,
	"desktopContainer": `StepOne-module__desktopContainer--iOd29`,
	"rightBoxImg": `StepOne-module__rightBoxImg--l54Py`,
	"riskTitle": `StepOne-module__riskTitle--JZn_s`,
	"modalDesc": `StepOne-module__modalDesc--Ie3pl`
};
export default ___CSS_LOADER_EXPORT___;
